import React from 'react'

export default function RegisterButton() {
  return (
    <button className='register-btb'>REGISTER</button>
  )
}
